__turbopack_context__.v({
  "left": "pageHeader-module-scss-module__THzuKa__left",
  "pageHeader": "pageHeader-module-scss-module__THzuKa__pageHeader",
  "title": "pageHeader-module-scss-module__THzuKa__title",
});
